<template>
    <b-container fluid>
      <search fields="Betrieb,Von,Bis,Probetyp,Tierart" :anaTabGraphic="true"   @filterdata="filterAnalysen"></search>
      <b-nav tabs>
        <b-nav-item :to="'/'+lang+'/analysen/tabelle'" ><strong><span class="glyphicons glyphicons-table"></span> {{$t('Tabelle')}}</strong></b-nav-item>
        <b-nav-item :to="'/'+lang+'/analysen/grafik'" active><strong><span class="glyphicons glyphicons-cardio"></span> {{$t('Grafik')}}</strong></b-nav-item>
      </b-nav>

         <b-form-group label="" class="mt-3">
           <b-form-select v-model="selectedChart"
                          :options="options"
                          text-field="text"
                          value-field="value"
                          class="bg-primary"
                          >
          </b-form-select>
        </b-form-group>
            <!-- :chartSeries="buildCS('MPDKEIME')" -->
        <charts-container ref="charts" title="" yLabel="" xLabel=""  ></charts-container>
    </b-container>
</template>

<script>
import ChartsContainer from "../components/ChartsContainer.vue";
import analysenMixin from "../components/AnalysenMixin.js";
import analysenCalcCharts from "../components/AnalysenCalcCharts_Mixin.js";
import analysenFilter from "../components/AnalysenFilter_Mixin.js";


//Vue.component('charts-container',ChartsContainer)

export default {
  name: "hello",
   props: {
    lang:String,
    },
  mixins: [
    analysenMixin,
    analysenCalcCharts,
    analysenFilter,
  ] /* call the mixins fn getChart() like am member fn:  this.getChart(); */,
  data() {
    return {
      analysenIntervall: 0,
      //tabIndex: 0,
      actionListener: {},
      filterText: "",      
      selected: ["MPDKEIME"], // Must be an array reference!
      selectedChart: "MPDKEIME",
      options: [
        { text: this.$t("Keime"), value: "MPDKEIME" },
        { text: this.$t("Zellen"), value: "MPDZELLEN" },
        { text: this.$t("Gefrierpunkt"), value: "MPDGEFRIERPUNKT" },
        {
          text: this.$t("Fett") + ", " + this.$t("Eiweiss"),
          value: "MPDFETT,MPDEIWEISS"
        },
        { text: this.$t("FreieFettsaeuren"), value: "MPDFETTSAEUREN" },
        { text: this.$t("Harnstoff"), value: "MPDHARNSTOFF" }
      ]
    };
  },
  components: {
    "charts-container": ChartsContainer,
  },
 
  watch: {
    selectedChart: function(newSelection) {
      this.setChartSerie(newSelection, this.betriebSelectedBtrIDs);
    },
    analysen: function() {
      this.setChartSerie(this.selectedChart, this.betriebSelectedBtrIDs);
    }
  }
};
</script>